import { useModal } from "@/packages";
import { createDate } from "@/utils";
import { API_RESERVE, type ReserveBookingResponse } from "@shared/server";
import { useMutation } from "@tanstack/react-query";
import { getDefaultParameters } from "@utils/getDefaultParameters";
import dayjs from "dayjs";
import { useState } from "react";

export const useBookParameter = () => {
    const [isLoading, setIsLoading] = useState(false);
    const { closeModal } = useModal();

    // const hostName = window.location.hostname;
    const mutation = useMutation({
        mutationFn: API_RESERVE.getReserveRoomInfo<ReserveBookingResponse>,
        onMutate: () => {
            setIsLoading(true);
        },
        onSuccess: (data) => {
            if (data.uid !== "") {
                const { currentObj } = createDate();
                const timeStamp = dayjs(currentObj).valueOf();
                const { idx, co_id } = getDefaultParameters();
                const { uid } = data;

                setIsLoading(false);
                closeModal();
                window
                    .open(
                        `https://calendar.marginauto.kr/payment?idx=${idx}&co_id=${co_id}&uid=${uid}&t=${timeStamp}`,
                        "_blank",
                        "noopener",
                    )
                    ?.focus();
            }
        },
    });

    return { mutation, isLoading };
};
